<span fxLayout="column" fxLayoutGap="20px">
  <span *ngIf="qualities?.humor" fxLayoutGap="10px" fxLayout="column" class="flimmo-card p-4">
    <span fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class="mat-subtitle-2">
      <div fxFlex="24px"><mat-icon>{{getIcon('humor')}}</mat-icon></div>
      <span>{{'besprechung.humor' | translate | titlecase}}</span>
    </span>
    <span fxLayout="row" class="mb1">{{qualities.humor}}</span>
  </span>
  <span *ngIf="qualities?.spannung" fxLayoutGap="10px" fxLayout="column" class="flimmo-card p-4">
    <span fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class="mat-subtitle-2">
      <div fxFlex="24px"><mat-icon>{{getIcon('spannung')}}</mat-icon></div>
      <span>{{'besprechung.spannung' | translate | titlecase}}</span>
    </span>
    <span fxLayout="row" class="mb1">{{qualities?.spannung}}</span>
  </span>
  <span *ngIf="qualities?.wissen" fxLayoutGap="10px" fxLayout="column" class="flimmo-card p-4">
    <span fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class="mat-subtitle-2">
      <div fxFlex="24px"><mat-icon>{{getIcon('wissen')}}</mat-icon></div>
      <span>{{'besprechung.wissen' | translate | titlecase}}</span>
    </span>
    <span fxLayout="row" class="mb1">{{qualities?.wissen}}</span>
  </span>
  <span *ngIf="qualities?.vorbild" fxLayoutGap="10px" fxLayout="column" class="flimmo-card p-4">
    <span fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class="mat-subtitle-2">
      <div fxFlex="24px"><mat-icon>{{getIcon('vorbild')}}</mat-icon></div>
      <span>{{'besprechung.vorbild' | translate | titlecase}}</span>
    </span>
    <span fxLayout="row" class="mb1">{{qualities?.vorbild}}</span>
  </span>
  <span *ngIf="qualities?.botschaft" fxLayoutGap="10px" fxLayout="column" class="flimmo-card p-4">
    <span fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class="mat-subtitle-2">
      <div fxFlex="24px"><mat-icon>{{getIcon('botschaft')}}</mat-icon></div>
      <span>{{'besprechung.botschaft' | translate | titlecase}}</span>
    </span>
    <span fxLayout="row" class="mb1">{{qualities?.botschaft}}</span>
  </span>
  <span *ngIf="qualities?.machart" fxLayoutGap="10px" fxLayout="column" class="flimmo-card p-4">
    <span fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class="mat-subtitle-2">
      <div fxFlex="24px"><mat-icon>{{getIcon('machart')}}</mat-icon></div>
      <span>{{'besprechung.machart' | translate | titlecase}}</span>
    </span>
    <span fxLayout="row" class="mb1">{{qualities?.machart}}</span>
  </span>
</span>
